export const ivKeys = {
  all: () => ['insuranceVerification'] as const,
  // Prefix of worklist(locationId, status) for all statuses — invalidates every filtered list.
  worklistPrefix: (locationId: string) => ['insuranceVerification', 'worklist', locationId] as const,
  worklist: (locationId: string, status?: string) =>
    ['insuranceVerification', 'worklist', locationId, status ?? 'all'] as const,
  metrics: (locationId: string) => ['insuranceVerification', 'metrics', locationId] as const,
  detail: (id: string) => ['insuranceVerification', 'detail', id] as const,
  // Templates and import fields are practice-scoped on the server (X-Practice-Id),
  // so an agency admin switching practices must not see the previous one's cache.
  templates: (practiceId: string) => ['insuranceVerification', 'templates', practiceId] as const,
  importFields: (practiceId: string) => ['insuranceVerification', 'import', 'fields', practiceId] as const,
  batches: (locationId: string) => ['insuranceVerification', 'import', 'batches', locationId] as const,
  connections: (locationId?: string) => ['insuranceVerification', 'connections', locationId ?? 'none'] as const,
  connectionsPrefix: () => ['insuranceVerification', 'connections'] as const,
  payerSearch: (q: string) => ['insuranceVerification', 'payers', 'search', q] as const,
};
